import * as ActionTypes from 'actions/personalInfo'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  personalInfo: [],
  partnerchildrens: [],
  selectedPartnerChildren: {},
}

// Updates error message to notify about the failed fetches.
export default function personalInfo(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.PERSONALINFO_GETING_PERSONALINFO:
      return Object.assign({}, state, {
        isFetching: true,
      })
    case ActionTypes.PERSONALINFO_RECEIVED_PERSONALINFO:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        personalInfo: action.personalInfo,
      }
    case ActionTypes.PERSONALINFO_UPDATING_PERSONALINFO:
      return {
        isFetching: true,
      }
    case ActionTypes.PERSONALINFO_UPDATED_PERSONALINFO:
      return {
        ...state,
        isFetching: false,
        fetched: true,

      }
    case ActionTypes.PARTNERCHILDREN_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.PARTNERCHILDREN_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        partnerchildrens: action.partnerchildrens,
      }
    case ActionTypes.PARTNERCHILDREN_SET_SELECTED:
      return {
        ...state,
        selectedPartnerChildren: action.children,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/personalInfo.js